import { v4 as uuidv4 } from "uuid";

class Bodyweight {
  constructor(id = uuidv4(), bodyweight = 0, date = Date(), client = null) {
    this.id = id;
    this.bodyweight = bodyweight;
    this.date = date;
    this.client = client;
  }

  uploadToCloud() {
    const data = {
      bodyweight: this.bodyweight,
      date: this.date || null,
      id: this.id.toString().toLowerCase(),
    };
    return data;
  }
}
export default Bodyweight;
